import React from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import Home from "./home";
import Login from "./login";
import LoginCheck from "./login-check";
import UserHome from "./userhome";
import CompileJS from "./compile-js";
import CreateCourse from "./create-course";
import withAuthentication from "./with-authentication";
import * as routes from "../constants/routes";
import "./app.css";

const App = () => {
  return (
    <Router>
      <div>
        <Route exact path={routes.LOGIN_CHECK} component={LoginCheck} />
        <Route exact path={routes.HOME} component={Home} />
        <Route exact path={routes.USER_HOME} component={UserHome} />
        <Route exact path={routes.LOGIN} component={Login} />
        <Route exact path={routes.COMPILE_JS} component={CompileJS} />
        <Route exact path={routes.CREATE_COURSE} component={CreateCourse} />
      </div>
    </Router>
  );
};

export default withAuthentication(App);
